import * as types from './mutation-types'

export default {
  [types.LOAD_CARD_STATUS](state, data) {
    state.status = data
  },
    [types.LOAD_CARDS](state, data) {
    state.cards = data
  },
  [types.LOAD_ASSIGNED_CARD](state, data) {
    state.assignedCard = data
  },
}

